import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Props } from 'docz';
import { Playground } from '@playground';
import { CheckboxChecked, CheckboxBlank, RadioButtonChecked, RadioButtonUnchecked, UnfoldMore, CheckedCircle, ErrorCircle, WarningCircle, ArrowUp, ArrowDown, ArrowLeft, ArrowRight, Cross, LoadingSpinnerCircle, LoadingSpinnerProgress } from './index';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "icons"
    }}>{`Icons`}</h1>
    <p>{`Icons for tpr apps`}</p>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`import { CheckboxChecked, CheckboxBlank, UnfoldMore } from '@tpr/icons';
`}</code></pre>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Components`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CheckboxChecked`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CheckboxBlank`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`RadioButtonChecked`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`RadioButtonUnchecked`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`UnfoldMore`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`CheckedCircle`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ErrorCircle`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`WarningCircle`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowUp`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowDown`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowLeft`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`ArrowRight`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Cross`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`LoadingSpinnerCircle`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`LoadingSpinnerProgress`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "checkbox"
    }}>{`Checkbox`}</h2>
    <Playground __position={0} __code={'<CheckboxChecked />\n<CheckboxBlank />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<CheckboxChecked mdxType="CheckboxChecked" />
	<CheckboxBlank mdxType="CheckboxBlank" />
    </Playground>
    <h2 {...{
      "id": "radio-button"
    }}>{`Radio Button`}</h2>
    <Playground __position={1} __code={'<RadioButtonChecked />\n<RadioButtonUnchecked />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<RadioButtonChecked mdxType="RadioButtonChecked" />
	<RadioButtonUnchecked mdxType="RadioButtonUnchecked" />
    </Playground>
    <h2 {...{
      "id": "unfoldmore"
    }}>{`UnfoldMore`}</h2>
    <Playground __position={2} __code={'<UnfoldMore />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<UnfoldMore mdxType="UnfoldMore" />
    </Playground>
    <h2 {...{
      "id": "checked-circle"
    }}>{`Checked Circle`}</h2>
    <Playground __position={3} __code={'<CheckedCircle fill=\"#1e7e34\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<CheckedCircle fill="#1e7e34" mdxType="CheckedCircle" />
    </Playground>
    <h2 {...{
      "id": "error-circle"
    }}>{`Error Circle`}</h2>
    <Playground __position={4} __code={'<ErrorCircle fill=\"#a91717\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<ErrorCircle fill="#a91717" mdxType="ErrorCircle" />
    </Playground>
    <h2 {...{
      "id": "warning-circle"
    }}>{`Warning Circle`}</h2>
    <Playground __position={5} __code={'<WarningCircle fill=\"#0b0030\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<WarningCircle fill="#0b0030" mdxType="WarningCircle" />
    </Playground>
    <h2 {...{
      "id": "arrow-up"
    }}>{`Arrow Up`}</h2>
    <Playground __position={6} __code={'<ArrowUp />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<ArrowUp mdxType="ArrowUp" />
    </Playground>
    <h2 {...{
      "id": "arrow-down"
    }}>{`Arrow Down`}</h2>
    <Playground __position={7} __code={'<ArrowDown />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<ArrowDown mdxType="ArrowDown" />
    </Playground>
    <h2 {...{
      "id": "arrow-left"
    }}>{`Arrow Left`}</h2>
    <Playground __position={8} __code={'<ArrowLeft />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<ArrowLeft mdxType="ArrowLeft" />
    </Playground>
    <h2 {...{
      "id": "arrow-right"
    }}>{`Arrow Right`}</h2>
    <Playground __position={9} __code={'<ArrowRight />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<ArrowRight mdxType="ArrowRight" />
    </Playground>
    <h2 {...{
      "id": "cross"
    }}>{`Cross`}</h2>
    <Playground __position={10} __code={'<Cross />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<Cross mdxType="Cross" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnercircle"
    }}>{`LoadingSpinnerCircle`}</h2>
    <Playground __position={11} __code={'<LoadingSpinnerCircle />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerCircle mdxType="LoadingSpinnerCircle" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnercircle-icon-only"
    }}>{`LoadingSpinnerCircle icon only`}</h2>
    <Playground __position={12} __code={'<LoadingSpinnerCircle iconOnly={true} />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerCircle iconOnly={true} mdxType="LoadingSpinnerCircle" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnercircle-with-custom-text"
    }}>{`LoadingSpinnerCircle with custom text`}</h2>
    <Playground __position={13} __code={'<LoadingSpinnerCircle text=\"Please wait while the app is loading ...\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerCircle text="Please wait while the app is loading ..." mdxType="LoadingSpinnerCircle" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnerprogress"
    }}>{`LoadingSpinnerProgress`}</h2>
    <Playground __position={14} __code={'<LoadingSpinnerProgress />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerProgress mdxType="LoadingSpinnerProgress" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnerprogress-icon-only"
    }}>{`LoadingSpinnerProgress icon only`}</h2>
    <Playground __position={15} __code={'<LoadingSpinnerProgress iconOnly={true} />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerProgress iconOnly={true} mdxType="LoadingSpinnerProgress" />
    </Playground>
    <h2 {...{
      "id": "loadingspinnerprogress-with-custom-text"
    }}>{`LoadingSpinnerProgress with custom text`}</h2>
    <Playground __position={16} __code={'<LoadingSpinnerProgress text=\"Please wait while the app is loading ...\" />'} __scope={{
      props,
      DefaultLayout,
      Props,
      Playground,
      CheckboxChecked,
      CheckboxBlank,
      RadioButtonChecked,
      RadioButtonUnchecked,
      UnfoldMore,
      CheckedCircle,
      ErrorCircle,
      WarningCircle,
      ArrowUp,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      Cross,
      LoadingSpinnerCircle,
      LoadingSpinnerProgress,
      DefaultLayout,
      _frontmatter
    }} mdxType="Playground">
	<LoadingSpinnerProgress text="Please wait while the app is loading ..." mdxType="LoadingSpinnerProgress" />
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      